/* eslint-disable react-hooks/exhaustive-deps */
import { AccountInfo } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useAppConfig } from "@fdoh/health-ui-react";
import { SelectOption } from "@fdoh/health-ui-react/build/ts/components/FormControl/FormControlSelect.types";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import InspectionClient from "../clients/InspectionJwtClient";
import { JwtResponse } from "../types";
import useAuthService from "./useAuthService";

export type Lookup =
  | "assignmentStatus"
  | "buisnessUnit"
  | "divisionOrOffice"
  | "category"
  | "role"
  | "workflowStatus";

export const useLookup = (name: Lookup): SelectOption[] => {
  const { instance, accounts } = useMsal();
  const config = useAppConfig();    
  const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];

  const jwtResponse = useAuthService<JwtResponse>(application);
  // console.log("useAuthService:: " + JSON.stringify(jwtResponse));
  const client = new InspectionClient(accounts[0] as AccountInfo, instance, application, jwtResponse);
  const [data, setData] = useState<SelectOption[]>([]);

  useEffect(() => {
    const getData = async () => {
      try {
        // Call API to get lookups.
        const response = await client.lookups(`lookups/${name}`).get();

        // Store results in constant.
        const list = response.data as SelectOption[];

        // Add default value to list.
        list.unshift({ id: "", name: "---" });

        // Add the values to the state.
        setData(list);
      } catch (error: any) {
        toast.error(error);
      }
    };

    getData();
  }, []);

  return data;
};

export default useLookup;
